import dayjs, { Dayjs } from 'dayjs';

export function showDayByHourOfDay(): Dayjs {
  const timeNow = dayjs(new Date());
  const shiftStartsIsh = 9;

  if (timeNow.isBefore(dayjs(new Date()).set('hour', shiftStartsIsh))) {
    const yesterDay = dayjs(timeNow).set('h', -24);
    return yesterDay;
  } else {
    return timeNow;
  }
}
